/* Femieko: reducere permanentă la cantitate pe pagina de produs (snippets/fe-qty-breaks.liquid).
   Varianta 1 lasă formularul temei neatins. La 2-3 bucăți, trimiterea formularului e preluată:
   toate bucățile intră în coș într-un singur apel /cart/add.js, fără proprietăți, apoi se deschide coșul temei.
   Prețul final îl dau reducerile automate native din Shopify (min. 2 / min. 3 bucăți din cele 7 categorii, combinate).
   La bucățile 2-3 se poate alege orice produs în stoc din cele 7 categorii (grupate, categoria paginii prima). */
(() => {
  if (customElements.get('fe-qty-breaks')) return;

  const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  // Formatul monedei pieței curente, dedus din {{ 123456 | money }} (ex. „1.234,56 lei”, „€1.234,56”, „1 234,56 zł”).
  const moneyFormatter = (sample) => {
    const m = String(sample || '').match(/1(\D?)234(\D)56/);
    if (!m) return (c) => (c / 100).toFixed(2);
    const [num, th, dec] = m;
    return (cents) => {
      const fixed = (Math.round(cents) / 100).toFixed(2).split('.');
      const int = fixed[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return sample.replace(num, int + dec + fixed[1]);
    };
  };

  class FeQtyBreaks extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.money = moneyFormatter(this.dataset.money);
      this.pct = { 1: 0, 2: Number(this.dataset.pct2) || 0, 3: Number(this.dataset.pct3) || 0 };
      try { this.current = JSON.parse(this.querySelector('[data-current]').textContent); } catch (e) { this.current = null; }
      if (!this.current) return;
      this.products = [this.current];
      try { this.groups = JSON.parse(this.querySelector('[data-groups]').textContent); } catch (e) { this.groups = []; }
      this.cats = null;
      const checked = this.querySelector('.fe-qb__radio:checked');
      this.tier = checked ? Number(checked.value) : 1;
      this.units = [];
      this.form = document.getElementById(this.dataset.form);
      this.$ = (s) => this.querySelector(s);
      this.$$ = (s) => [...this.querySelectorAll(s)];

      this.addEventListener('change', (e) => this.onChange(e));
      this.onSubmit = this.onSubmit.bind(this);
      document.addEventListener('submit', this.onSubmit, true);
      if (this.form) this.form.addEventListener('change', () => requestAnimationFrame(() => this.refresh()));
      if (window.FoxTheme && FoxTheme.pubsub) {
        this.unsub = FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, () => requestAnimationFrame(() => this.refresh()));
      }
      if (this.form) this.form.classList.add('fe-qb-form');
      this.renderUnits();
      this.refresh();
      if (this.tier > 1) (window.requestIdleCallback || ((cb) => setTimeout(cb, 400)))(() => this.loadGroup());
    }

    disconnectedCallback() {
      document.removeEventListener('submit', this.onSubmit, true);
      if (this.unsub) this.unsub();
    }

    t(key, map) {
      let s = this.dataset['t' + key] || '';
      Object.keys(map || {}).forEach((k) => { s = s.replace('[' + k + ']', map[k]); });
      return s;
    }

    // varianta aleasă în selectorul principal al temei
    mainVariant() {
      const input = this.form && this.form.querySelector('[name="id"]');
      const id = input ? Number(input.value) : 0;
      return this.current.v.find((x) => x.id === id) || this.current.v.find((x) => x.a) || this.current.v[0];
    }

    productById(id) {
      return this.products.find((p) => p.id === Number(id));
    }

    // toate cele 7 categorii (categoria paginii prima); doar produsele în stoc, fiecare o singură dată
    async loadGroup() {
      if (this._groupLoaded || this._groupLoading) return this._groupLoading;
      const get = (g) => fetch(g.u, { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.text() : '[]'))
        .then((txt) => { let list = []; try { list = JSON.parse(txt.trim()); } catch (e) { list = []; } return Array.isArray(list) ? list : []; })
        .catch(() => []);
      this._groupLoading = Promise.all(this.groups.map(get)).then((lists) => {
        const seen = new Set([this.current.id]);
        const cats = [];
        lists.forEach((list, gi) => {
          const ids = gi === 0 ? [this.current.id] : [];
          list.forEach((p) => {
            if (!p || seen.has(p.id) || !p.v || !p.v.some((x) => x.a)) return;
            seen.add(p.id);
            this.products.push(p);
            ids.push(p.id);
          });
          if (ids.length) cats.push({ t: this.groups[gi].t, ids });
        });
        this.cats = cats;
        this.disambiguate();
        this._groupLoaded = true;
        this.renderUnits();
      });
      return this._groupLoading;
    }

    // produse cu același nume scurt (ex. cupe S/M, Galaxy slip/sutien): se adaugă partea din titlu care le deosebește
    disambiguate() {
      const by = new Map();
      // culoarea se compară după primele 5 litere (pl: „Fioletowe” / „Fioletowy”)
      const key = (t) => { const i = t.lastIndexOf(' · '); return i > 0 ? t.slice(0, i) + '|' + t.slice(i + 3, i + 8).toLowerCase() : t; };
      this.products.forEach((p) => { const k = key(p.t); if (!by.has(k)) by.set(k, []); by.get(k).push(p); });
      by.forEach((list) => {
        if (list.length < 2) return;
        list.forEach((p) => {
          const own = (p.m || []).filter((x) => !list.every((o) => (o.m || []).includes(x)));
          if (!own.length) return;
          const i = p.t.lastIndexOf(' · ');
          p.t = i > 0 ? p.t.slice(0, i) + ' · ' + own[0] + p.t.slice(i) : p.t + ' · ' + own[0];
        });
      });
    }

    modelOptions(selId) {
      const opt = (m) => '<option value="' + m.id + '"' + (m.id === selId ? ' selected' : '') + '>' + esc(m.t) + '</option>';
      if (!this.cats || this.cats.length < 2) return this.products.map(opt).join('');
      return this.cats.map((c) => '<optgroup label="' + esc(c.t) + '">' + c.ids.map((id) => opt(this.productById(id))).join('') + '</optgroup>').join('');
    }

    onChange(e) {
      const radio = e.target.closest('.fe-qb__radio');
      if (radio) {
        this.tier = Number(radio.value);
        this.$$('.fe-qb__tier').forEach((el) => el.classList.toggle('is-on', el.dataset.tier === radio.value));
        if (this.tier > 1) this.loadGroup();
        this.renderUnits();
        this.refresh();
        return;
      }
      const sel = e.target.closest('select[data-i]');
      if (!sel) return;
      const i = Number(sel.dataset.i);
      const u = this.units[i];
      if (sel.dataset.kind === 'model') {
        const p = this.productById(sel.value);
        u.pid = p.id;
        const same = p.v.find((x) => x.a && x.n === u.vname);
        const pick = same || p.v.find((x) => x.a) || p.v[0];
        u.vid = pick.id;
        u.vname = pick.n;
        this.renderUnits();
      } else {
        u.vid = Number(sel.value);
        const p = this.productById(u.pid);
        const vv = p && p.v.find((x) => x.id === u.vid);
        u.vname = vv ? vv.n : '';
        const row = sel.closest('.fe-qb__unit');
        const old = row && row.querySelector('.fe-qb__thumb');
        if (old) old.outerHTML = this.thumb(p, vv);
      }
      this.refresh();
    }

    // bucățile 2..n: implicit același produs și aceeași variantă ca în selectorul principal
    syncUnits() {
      const mv = this.mainVariant();
      const need = Math.max(0, this.tier - 1);
      while (this.units.length < need) this.units.push({ pid: this.current.id, vid: mv.id, vname: mv.n });
      return mv;
    }

    lines() {
      const mv = this.syncUnits();
      const out = [{ p: this.current, v: mv }];
      this.units.slice(0, this.tier - 1).forEach((u) => {
        const p = this.productById(u.pid) || this.current;
        const v = p.v.find((x) => x.id === u.vid) || p.v.find((x) => x.a) || p.v[0];
        out.push({ p, v });
      });
      return out;
    }

    refresh() {
      const mv = this.syncUnits();
      [1, 2, 3].forEach((n) => {
        const card = this.$('.fe-qb__tier[data-tier="' + n + '"]');
        if (!card) return;
        let full;
        if (n === this.tier) full = this.lines().reduce((s, l) => s + l.v.p, 0);
        else full = mv.p * n;
        const off = this.offFor(n, n === this.tier ? this.lines() : Array(n).fill({ v: mv }));
        const price = card.querySelector('[data-price]');
        if (price) price.textContent = this.money(full - off);
        const fullEl = card.querySelector('[data-full]');
        if (fullEl) fullEl.textContent = this.money(full);
        const save = card.querySelector('[data-save]');
        if (save) save.textContent = this.t('Save', { x: this.money(off) });
      });
      const first = this.$('[data-unit-first]');
      if (first) first.textContent = this.label(this.current, mv);
      const ft = this.$('[data-unit-thumb]');
      if (ft) { const src = (mv && mv.i) || this.current.i; const img = ft.querySelector('img'); if (img && src && img.getAttribute('src') !== src) img.setAttribute('src', src); }
    }

    offFor(n, lines) {
      const pct = this.pct[n] || 0;
      return lines.reduce((s, l) => s + Math.round((l.v.p * pct) / 100), 0);
    }

    label(p, v) {
      return v && v.n && v.n !== 'Default Title' ? p.t + ' · ' + v.n : p.t;
    }

    thumb(p, v) {
      const src = (v && v.i) || p.i;
      return src
        ? '<img class="fe-qb__thumb" src="' + esc(src) + '" alt="" width="44" height="44" loading="lazy" decoding="async">'
        : '<span class="fe-qb__thumb" aria-hidden="true"></span>';
    }

    renderUnits() {
      const box = this.$('[data-units]');
      const list = this.$('[data-unit-list]');
      if (!box || !list) return;
      box.hidden = this.tier < 2;
      if (this.tier < 2) return;
      const mv = this.syncUnits();
      let html = '<div class="fe-qb__unit"><span data-unit-thumb>' + this.thumb(this.current, mv) + '</span><div class="fe-qb__unit-body"><span class="fe-qb__unit-n">' + esc(this.t('Unit', { n: 1 })) + '</span>' +
        '<span class="fe-qb__unit-fixed" data-unit-first>' + esc(this.label(this.current, mv)) + '</span></div></div>';
      this.units.slice(0, this.tier - 1).forEach((u, i) => {
        const n = i + 2;
        const p = this.productById(u.pid) || this.current;
        const uv = p.v.find((x) => x.id === u.vid);
        const models = this.modelOptions(p.id);
        const single = p.v.length === 1 && p.v[0].n === 'Default Title';
        const variants = p.v.filter((x) => x.a || x.id === u.vid).map((x) => '<option value="' + x.id + '"' + (x.id === u.vid ? ' selected' : '') + (x.a ? '' : ' disabled') + '>' + esc(x.n) + '</option>').join('');
        const mid = this._uid || (this._uid = 'fe-qb-' + Math.random().toString(36).slice(2, 7));
        html += '<div class="fe-qb__unit">' + this.thumb(p, uv) + '<div class="fe-qb__unit-body"><span class="fe-qb__unit-n">' + esc(this.t('Unit', { n })) + '</span>' +
          '<span class="fe-qb__sel' + (single ? ' fe-qb__sel--full' : '') + '"><label class="fe-qb__sr" for="' + mid + '-m' + i + '">' + esc(this.t('Model', { n })) + '</label>' +
          '<select id="' + mid + '-m' + i + '" data-i="' + i + '" data-kind="model">' + models + '</select></span>' +
          (single ? '' : '<span class="fe-qb__sel fe-qb__sel--v"><label class="fe-qb__sr" for="' + mid + '-v' + i + '">' + esc(this.t('Variant', { n })) + '</label>' +
          '<select id="' + mid + '-v' + i + '" data-i="' + i + '" data-kind="variant">' + variants + '</select></span>') +
          '</div></div>';
      });
      list.innerHTML = html;
    }

    async onSubmit(e) {
      if (this.tier < 2 || !this.form || e.target !== this.form) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      const btn = e.submitter || this.form.querySelector('[type="submit"]');
      if (btn && btn.hasAttribute('aria-disabled')) return;
      const counts = new Map();
      this.lines().forEach((l) => counts.set(l.v.id, (counts.get(l.v.id) || 0) + 1));
      const items = [...counts].map(([id, quantity]) => ({ id, quantity }));
      const err = this.$('[data-error]');
      if (err) err.hidden = true;
      if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('btn--loading'); }
      try {
        const res = await fetch(this.dataset.cartAdd, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        });
        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.description || data.message || String(res.status));
        }
        const drawer = document.querySelector('cart-drawer');
        if (drawer && !(window.FoxTheme && FoxTheme.settings && FoxTheme.settings.cartType === 'page')) {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        } else {
          window.location.href = this.dataset.cartUrl;
        }
      } catch (ex) {
        if (err) {
          err.textContent = this.t('Error') + (ex.message && !/^\d+$/.test(ex.message) ? ' (' + ex.message + ')' : '');
          err.hidden = false;
        }
      } finally {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('btn--loading'); }
      }
    }
  }

  customElements.define('fe-qty-breaks', FeQtyBreaks);
})();
